import React from 'react';
import styled, { css } from 'styled-components';

import bubblesSVG from '~images/notice_bubbles.svg';

import { primaryColor } from '~theme';

const NoticeBubbles = ({ content, wide }) => {
  return (
    <Container>
      <Bubbles src={bubblesSVG} />
      <Content>{content}</Content>
      <Arrow wide={wide}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="18"
          viewBox="0 0 24 18"
        >
          <path d="M12,0,24,18H0Z" fill="#f2f2f2" />
        </svg>
      </Arrow>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  padding: 24px;
  background-color: #f2f2f2;
  display: flex;
  max-width: var(--field-width);
`;

const Bubbles = styled.img`
  height: 48px;
`;

const Content = styled.div`
  margin-left: 16px;
  color: ${primaryColor};
`;

const Arrow = styled.div`
  position: absolute;
  left: 12px;
  top: -18px;
  ${p =>
    p.wide
      ? css`
          transform: rotate(-90deg);
          left: -20px;
          top: 10px;
        `
      : ''}
  transition: all 0.2s ease-in-out;
`;

export default NoticeBubbles;
